import user from '../store/user/index'

// 权限检查方法
export default function has (value) {
  let isDisabled = true
  // 获取用户按钮权限
  let btnPermissionsStr = user.state.userinfo.buttonList
  if (btnPermissionsStr && btnPermissionsStr.indexOf(value) > -1) {
    isDisabled = false
  }
  // isDisabled = false
  return isDisabled
}



// WEBPACK FOOTER //
// ./src/utils/permission.js